import { Box, Text, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { LocationSelector } from 'modules/it_management/components/LocationSelector'

import { WizardData } from './types'

const AssignmentStep: React.FC<WizardStepRenderParams<WizardData>> = ({ data, onDataChanged }) => {
  return (
    <Box gap="s32" maxWidth="s400">
      <Title
        description={i18n.t('it_management.assignment_step.description')}
        title={i18n.t('it_management.assignment_step.title')}
      />
      <Box gap="s16" paddingRight="s24">
        <Box gap="s8">
          <Text.Normal size="200" weight="medium" color="grey800">
            {i18n.t('it_management.assignment_step.employee')}
          </Text.Normal>
          <EmployeeSelectorV2
            value={data.employeeId ?? undefined}
            onChange={(employeeId) => {
              onDataChanged({
                ...data,
                employeeId: employeeId,
              })
            }}
          />
        </Box>

        <LocationSelector
          value={
            data.locationId && data.locationName
              ? {
                  id: data.locationId,
                  name: data.locationName,
                }
              : null
          }
          label={i18n.t('it_management.assignment_step.space')}
          emptyLabel={i18n.t('it_management.assignment_step.empty_label')}
          onSelect={(location) => {
            onDataChanged({
              ...data,
              locationId: location?.id || undefined,
              locationName: location?.name || undefined,
            })
          }}
        />
      </Box>
    </Box>
  )
}

export default AssignmentStep
